<template>
  <v-row>
    <v-col cols="12">
      <Filtro/>
    </v-col>
    <v-col cols="12">
      <TableInadimplencia/>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'Inadimplencia',

  components: {
    Filtro: () => import("./components/Filtro"),
    TableInadimplencia: () => import("./components/TableInadimplencia")
  }
}
</script>